import React, { useState, useEffect } from 'react';
import { Modal,Button, Dropdown, FormGroup, Form, DropdownButton } from 'react-bootstrap';
import {changeMesaSalon } from '../../../../../../../../../../crud/management_api/mesas';
import {toast} from 'react-toastify';
import MiniLoadingSpinner from '../../../../../../../../../../components/Spinners/MiniLoadingSpinner';
import { X } from 'react-bootstrap-icons';


interface ChangeSalonProps {
    show: boolean;
    setShow: (show: boolean) => void;
    mesaId: number;
    salones: any[];
    setSalones: (salones: any[]) => void;
    selectedSalon: any;
    setSelectedSalon: (salon: any) => void;
    onMoveComplete?: (updatedSalones?: any[]) => void;
}

const ChangeSalon: React.FC<ChangeSalonProps> = ({
    show,
    setShow,
    mesaId,
    salones,
    setSalones,
    selectedSalon,
    setSelectedSalon,
    onMoveComplete
}) => {
    const [newSalon, setNewSalon] = useState<any>(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setNewSalon(selectedSalon);
    }, [selectedSalon]);

    const handleChangeSalon = () => {
      if (!newSalon) return;
  
      setLoading(true);
  
      changeMesaSalon(mesaId, newSalon.salon_id)
        .then(() => {
          // 1) Encuentra el salón origen
          const originSalon = salones.find(
            s => s.salon_id === selectedSalon.salon_id
          );
          if (!originSalon) {
            throw new Error('Salón origen no encontrado');
          }
  
          // 2) Usa 'id' para filtrar y encontrar la mesa
          const movedMesa = originSalon.mesas.find(
            (m: any) => m.id === mesaId
          );
          const updatedMesas = originSalon.mesas.filter(
            (m: any) => m.id !== mesaId
          );
  
          // 3) Reconstruye lista de salones
          const newSalones = salones.map(salon => {
            if (salon.salon_id === originSalon.salon_id) {
              // elimina la mesa del salón origen
              return { ...salon, mesas: updatedMesas };
            }
            if (salon.salon_id === newSalon.salon_id && movedMesa) {
              // agrega la mesa al salón destino
              return { ...salon, mesas: [...salon.mesas, movedMesa] };
            }
            return salon;
          });
  
          setSalones(newSalones);
          setSelectedSalon(
            newSalones.find(s => s.salon_id === newSalon.salon_id)!
          );
          toast.success('Mesa cambiada con éxito');
          
          // Notificar al padre que la operación terminó
          onMoveComplete?.(newSalones);
        })
        .catch(error => {
          console.error('Error changing salon:', error);
          toast.error('Error al cambiar salón');
        })
        .finally(() => {
          setLoading(false);
          setShow(false);
        });
    };
   

    return (
        <Modal show={show} onHide={() => setShow(false)}>
          <Modal.Header>
            <div className="form-modal-title-container">
              <Modal.Title className="form-modal-title">Cambiar salón</Modal.Title>
            </div>
            <Button variant="none" className="modal-close-button" onClick={() => setShow(false)}>
              <X size={24} />
            </Button>
          </Modal.Header>
      
          <Modal.Body>
            {loading ? (
              <MiniLoadingSpinner />
            ) : (
              <Form>
                <Form.Group className="mp-formgroup horizontal">
                  <Form.Label>Selecciona un salón</Form.Label>
                  <DropdownButton
                    id="dropdown-basic"
                    className="mp-dropdown"
                    variant="none"
                    title={newSalon?.salon_name || 'Selecciona un salón'}
                  >
                    {salones?.map((salon: any) => (
                      <Dropdown.Item key={salon.salon_id} onClick={() => setNewSalon(salon)}>
                        {salon.salon_name}
                      </Dropdown.Item>
                    ))}
                  </DropdownButton>
                </Form.Group>
              </Form>
            )}
          </Modal.Body>
      
          <Modal.Footer>
            <div className="form-modal-footer-custom">
              <Button
                className="form-button-cancel"
                variant="none"
                onClick={() => setShow(false)}
                disabled={loading}
              >
                Cancelar
              </Button>
              <Button
                className="form-button-create"
                variant="none"
                type="submit"
                disabled={loading}
                onClick={handleChangeSalon} // Se agrega el evento onClick
              >
                Cambiar
              </Button>
            </div>
          </Modal.Footer>
        </Modal>
      );
      
};

export default ChangeSalon;